import moment from 'moment'

export default {
	computed: {
		startDateFormatted() {
			return moment(this.tournament.startDate).format("MMMM Do, YYYY");
		},
		signupAs() {
			return this.tournament.externalLink
				? "External"
				: this.tournament.individualRegistration ? "Individual" : "Team";
		},
		hasRegistrationEnded() {
			let endsAt = moment(this.tournament.registrationEnds, "YYYY-MM-DD");
			let now = moment();
			return moment.duration(now - endsAt).days() <= 0;
		},
	}
}